import { useEffect, useState } from "react";
import { CalendarClock, Leaf, PlayCircle, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { Markdown, PageHeader, fmtDate } from "@/components/Bits";

const embedUrl = (u) => {
  const yt = u.match(/(?:youtu\.be\/|v=)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = u.match(/vimeo\.com\/(\d+)/);
  return vm ? `https://player.vimeo.com/video/${vm[1]}` : null;
};

const Early = () => <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-sun/30 text-navy px-2 py-0.5 text-[10px] font-mono uppercase"><Sparkles className="h-3 w-3" />Pro early access</span>;

export const SeasonalIdeas = ({ limit }) => {
  const [ideas, setIdeas] = useState([]);
  useEffect(() => { api.get("/seasonal-ideas").then((r) => setIdeas(r.data)).catch(() => {}); }, []);
  if (!ideas.length) return null;
  return (
    <div className="grid gap-4 md:grid-cols-2" data-testid="seasonal-ideas">
      {ideas.slice(0, limit || 50).map((i) => (
        <div key={i.id} className="rounded-2xl border border-border bg-card p-5" data-testid={`idea-${i.id}`}>
          <div className="flex items-center gap-2 text-xs text-muted-foreground"><Leaf className="h-4 w-4 text-leaf" />Until {fmtDate(i.publish_to)}{i.early && <Early />}</div>
          <div className="font-serif uppercase text-lg text-navy mt-2">{i.title}</div>
          <p className="text-sm text-muted-foreground mt-1">{i.body}</p>
        </div>
      ))}
    </div>
  );
};

export default function Drops() {
  const [drops, setDrops] = useState([]);
  useEffect(() => { api.get("/drops").then((r) => setDrops(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader eyebrow="From Lindsay" title="Seasonal ideas & content drops." />
      <h2 className="font-serif uppercase text-xl text-navy mb-4 flex items-center gap-2"><CalendarClock className="h-5 w-5 text-pinkb" />In season now</h2>
      <SeasonalIdeas />
      <h2 className="font-serif uppercase text-xl text-navy mt-12 mb-4 flex items-center gap-2"><PlayCircle className="h-5 w-5 text-pinkb" />Content drops</h2>
      {drops.length === 0 && <p className="text-sm text-muted-foreground" data-testid="drops-empty">Nothing yet. Lindsay shares videos and written pieces here as she publishes them.</p>}
      <div className="space-y-6 max-w-3xl">
        {drops.map((d) => (
          <article key={d.id} className="rounded-2xl border border-border bg-card p-6" data-testid={`drop-${d.id}`}>
            <div className="text-xs text-muted-foreground">{fmtDate(d.created_at)}{d.early && <Early />}</div>
            <h3 className="font-serif uppercase text-2xl text-navy mt-1">{d.title}</h3>
            {d.video_url && (embedUrl(d.video_url)
              ? <div className="mt-4 aspect-video rounded-xl overflow-hidden bg-black"><iframe src={embedUrl(d.video_url)} title={d.title} className="h-full w-full" allowFullScreen /></div>
              : <a href={d.video_url} target="_blank" rel="noreferrer" className="mt-3 inline-block text-pinkb underline">Watch the video</a>)}
            {d.body && <div className="mt-4"><Markdown>{d.body}</Markdown></div>}
          </article>
        ))}
      </div>
    </div>
  );
}
